/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProfilingWizardStatusResponse,
} from '../models/index';
import {
    ProfilingWizardStatusResponseFromJSON,
    ProfilingWizardStatusResponseToJSON,
} from '../models/index';

export interface GetProfilingWizardStatusRequest {
    brUid: string;
}

/**
 * 
 */
export class ProfilingWizardApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProfilingWizardStatus without sending the request
     */
    async getProfilingWizardStatusRequestOpts(requestParameters: GetProfilingWizardStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getProfilingWizardStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/profilingWizard/{brUid}/status`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the Profiling Wizard status and reason for the specified business relationship.
     * Get Profiling Wizard status
     */
    async getProfilingWizardStatusRaw(requestParameters: GetProfilingWizardStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfilingWizardStatusResponse>> {
        const requestOptions = await this.getProfilingWizardStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfilingWizardStatusResponseFromJSON(jsonValue));
    }

    /**
     * Returns the Profiling Wizard status and reason for the specified business relationship.
     * Get Profiling Wizard status
     */
    async getProfilingWizardStatus(requestParameters: GetProfilingWizardStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfilingWizardStatusResponse> {
        const response = await this.getProfilingWizardStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
